"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var action_1 = require("./action");
var spyRefCount = 0;
var spyDisposer = null;
function initializeSpy() {
    if (spyRefCount === 0) {
        spyDisposer = mobx_1.spy(spyOnChanges);
    }
    spyRefCount++;
}
function disposeSpy() {
    spyRefCount--;
    if (spyRefCount === 0) {
        spyDisposer();
        spyDisposer = null;
    }
}
var undoWindows = [];
function spyOnChanges(event) {
    var undoStep;
    var modifiedObject = event.object;
    switch (event.type) {
        case 'update':
            if (event.index !== undefined) {
                undoStep = {
                    verify: function () { return modifiedObject[event.index] === event.newValue; },
                    objectName: event.name,
                    propertyName: event.index,
                    undo: function () {
                        modifiedObject[event.index] = event.oldValue;
                    },
                };
            }
            else if (typeof modifiedObject.get !== 'undefined') {
                undoStep = {
                    verify: function () { return modifiedObject.get(event.key) === event.newValue; },
                    objectName: event.name,
                    propertyName: event.key,
                    undo: function () {
                        modifiedObject.set(event.key, event.oldValue);
                    },
                };
            }
            else {
                undoStep = {
                    verify: function () { return modifiedObject[event.key] === event.newValue; },
                    objectName: event.name,
                    propertyName: event.key,
                    undo: function () {
                        modifiedObject[event.key] = event.oldValue;
                    },
                };
            }
            break;
        case 'splice':
            undoStep = {
                verify: function () {
                    for (var i = 0; i < event.addedCount; i++) {
                        if (modifiedObject[event.index + i] !== event.added[i]) {
                            return false;
                        }
                    }
                    return true;
                },
                objectName: event.name,
                propertyName: event.index,
                undo: function () {
                    modifiedObject.splice(event.index, event.addedCount);
                    for (var i = 0; i < event.removedCount; i++) {
                        modifiedObject.splice(event.index + i, 0, event.removed[i]);
                    }
                },
            };
            break;
        case 'add':
            if (typeof modifiedObject.get !== 'undefined') {
                undoStep = {
                    verify: function () { return modifiedObject.get(event.key) === event.newValue; },
                    objectName: event.name,
                    propertyName: event.key,
                    undo: function () {
                        modifiedObject.delete(event.key);
                    },
                };
            }
            else {
                undoStep = {
                    verify: function () { return modifiedObject[event.key] === event.newValue; },
                    objectName: event.name,
                    propertyName: event.key,
                    undo: function () {
                        delete modifiedObject[event.key];
                    },
                };
            }
            break;
        case 'delete':
            undoStep = {
                verify: function () { return !modifiedObject.has(event.key); },
                objectName: event.name,
                propertyName: event.key,
                undo: function () {
                    modifiedObject.set(event.key, event.oldValue);
                },
            };
            break;
        default:
            return;
    }
    undoWindows.forEach(function (undoWindow) { return undoWindow.steps.push(undoStep); });
}
function trackUndo(actionName, action, undoVerifiesChanges) {
    initializeSpy();
    undoWindows.push({ steps: [] });
    try {
        var returnValue = action();
        var undoWindow_1 = undoWindows[undoWindows.length - 1];
        var undoPreviouslyExecuted_1 = false;
        undoWindow_1.steps.reverse();
        var undo = action_1.default("undo-" + actionName)(function () {
            if (undoPreviouslyExecuted_1) {
                throw "This instance of undo-" + actionName + " has already been executed";
            }
            if (undoVerifiesChanges) {
                undoWindow_1.steps.forEach(function (step) {
                    if (!step.verify()) {
                        throw "Property \"" + step.propertyName + " on store object \"" + step.objectName + " changed since action was performed.";
                    }
                });
            }
            undoWindow_1.steps.forEach(function (step) { return step.undo(); });
            undoPreviouslyExecuted_1 = true;
        });
        undo.actionReturnValue = returnValue;
        return undo;
    }
    finally {
        undoWindows.pop();
        disposeSpy();
    }
}
function createUndo(actionName, undoVerifiesChanges) {
    return function (action) {
        return trackUndo(actionName, action, !!undoVerifiesChanges);
    };
}
exports.default = createUndo;
